import Vue from 'vue'
import App from './App.vue'
import router, { isNavigationDuplicated } from './router'

Vue.config.productionTip = false

window.addEventListener('unhandledrejection', event => {
  const reason = event.reason
  const message = reason && (reason.message || String(reason))
  if (isNavigationDuplicated(reason)) {
    event.preventDefault()
    return
  }
  if (message && message.includes('Cannot redefine property: disableDevtool')) {
    event.preventDefault()
  }
})

window.addEventListener('error', event => {
  const message = event.message || ''
  if (message.includes('Cannot redefine property: disableDevtool')) {
    event.preventDefault()
  }
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
